import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useAppSelector } from 'src/services/redux/app/Store';

const VENDOR_MC_OMS_URL = `${process.env.REACT_APP_API_OMS_URL}`;

interface DelayedShipmentResponse {
  shipmentActions?: {
    late_shipment_count?: number;
  };
}

export const useDelayedShipmentCheck = () => {
  const { user } = useAppSelector((state) => state.auth);

  const { data, isLoading, isError, isSuccess } = useQuery<DelayedShipmentResponse>(
    ['delayed-shipment-check', user?.vendor?.id],
    async () => {
      const response = await axios.get(`${VENDOR_MC_OMS_URL}/dashboard/${user?.vendor?.id}/v2`);
      return response.data;
    },
    {
      enabled: Boolean(user?.vendor?.id),
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 5, // 5 dakika
      cacheTime: 1000 * 60 * 10, // 10 dakika
    }
  );

  const lateShipmentCount = data?.shipmentActions?.late_shipment_count ?? 0;
  const hasDelayedShipment = lateShipmentCount > 0;

  return {
    hasDelayedShipment,
    lateShipmentCount,
    isLoading,
    isError,
    isSuccess,
  };
};

